import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import ExpenseRecognitionFilters from "./components/ExpenseRecognitionFilters";
import ExpenseRecognitionTable from "./components/ExpenseRecognitionTable";
import { fetchExpenseRecognition } from "./expenseRecognitionThunk";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import { exportExpenseRecognitionCsv } from "./components/exportExpenseRecognitionCsv.js";

const { Title } = Typography;

const ExpenseRecognitionRecord = () => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

const { filters, list } = useSelector((state) => state.expenseRecognition);
  useEffect(() => {
    dispatch(fetchExpenseRecognition({})); // initial load
  }, [dispatch]);

  const navigate = useNavigate();

  const handleNavigateToReports = () => {
    navigate("/reports");
  };

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Expense Recognition Report",
    removeAfterPrint: true,
  });
 const handleDownloadCsv = () => {
    exportExpenseRecognitionCsv({
      list,
      filters,
      title:    "Expense Recognition Record",
      filename: "expense_recognition_record",
    });
  };

  const hasData = list.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />
            <Title level={4} style={{ margin: 0 }} className="reportBigTitle">
              Expense Recognition Record
            </Title>
            </div>
          }
         extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <ExpenseRecognitionFilters messageApi={message} />
        <Card className="shadow-md rounded-xl">
          <ExpenseRecognitionTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Expense Recognition Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <ExpenseRecognitionTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default ExpenseRecognitionRecord;
